export enum ChangelogStatus {
  DRAFT = -1,
  PUBLISHED = -2,
}
